import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";
import useStyles from "./Styles";
import { useSelector } from "react-redux";
import { toolbarHeight } from "components/app/Styles";
import { filterContainerHeight, chartTitleHeight } from "./Styles";
import { getWindowSize } from "./utils";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

function CentralArizonaStackBar() {
  const classes = useStyles();
  const { priority_entitlements, scenario } = useSelector(
    (state) => state.central_arizona
  );
  const { isMobile } = useGetViewPortDimensions();
  const [windowSize, setWindowSize] = useState(getWindowSize());

  //gets windowSize to set width of barchart
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const getDataForPool = (priority_name) => {
    const data = [];
    const scenarioData = priority_entitlements[scenario];
    Object.keys(scenarioData)
      .reverse()
      .forEach((water_available) =>
        data.push(scenarioData[water_available][priority_name])
      );
    return data;
  };

  const getXValues = () => {
    let xAxisValues = Object.keys(priority_entitlements[scenario])
      .reverse()
      .map((key) => {
        const currKey = parseInt(key);
        if (currKey < 1000000) {
          return `${currKey / 1000}K`;
        } else {
          return `${currKey / 1000000}M`;
        }
      });
    return xAxisValues;
  };

  const options = {
    chart: {
      type: "column",
      // plotBackgroundColor: "#97B0DC",
      // plotBackgroundColor: "#E5E9EE",
      backgroundColor: "#E5E9EE",
      width: isMobile ? 380 : windowSize.innerWidth - 500,
      height:
        windowSize.innerHeight -
        toolbarHeight -
        filterContainerHeight -
        chartTitleHeight -
        75,
    },
    title: {
      text: undefined,
    },
    series: [
      {
        name: "NIA",
        data: getDataForPool("nia_priority_contract_entitlement"),
        color: "#2352D0",
        legendIndex: 0,
      },

      {
        name: "M&I",
        data: getDataForPool("mi_priority_contract_entitlement"),
        color: "#6AA4DC",
        legendIndex: 1,
      },
      {
        name: "Indian",
        data: getDataForPool("indian_priority_contract_entitlement"),
        color: "#F3C745",
        legendIndex: 2,
      },
      {
        name: "P3",
        data: getDataForPool("p13_contract_entitlement"),
        color: "#DE3E40",
        legendIndex: 3,
      },
    ],
    plotOptions: {
      column: {
        stacking: "normal",
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
        },
        borderWidth: 0,
        events: {
          legendItemClick: function () {
            return false; // <== returning false will cancel the default action
          },
        },
      },
      //   series: {
      //     pointWidth: 100,
      //   },
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      title: {
        text: "Water Available (acre-feet)",
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
      categories: getXValues(),
      labels: {
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
    },
    yAxis: {
      min: 0,

      title: {
        text: "Colorado River Allocation (acre-feet)",
        margin: 40,
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "16px",
        },
      },
      labels: {
        style: {
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "14px",
        },
        formatter: function () {
          if (this.value >= 1000000) {
            return this.value / 1000000 + "M";
          } else if (this.value >= 1000) {
            return this.value / 1000 + "K";
          } else {
            return this.value;
          }
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#C4C4C4",
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      reversed: false,
      title: {
        // text: "<span style='font-size:12px; color:#666; font-weight:normal font-family:Arial'>Legend</span>",
        // style: {
        //   fontStyle: "normal",
        // },
      },
      itemStyle: {
        color: "#333333",
        fontSize: "12px",
        fontWeight: "normal",
        fontFamily: "Arial",
      },
      align: "center",
      x: 50,
      backgroundColor: "#FFFFFF",
      borderColor: "#E0E0E0",
      borderWidth: 1,
      borderRadius: 15,
      padding: 10,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      shadow: {
        offsetX: -1,
        offsetY: 3,
        color: "#00000029",
        width: 4,
      },
    },
  };

  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
}

export default CentralArizonaStackBar;
